module.exports = __webpack_public_path__ + "img/udgravning_af_soe.bc0e6ae2.jpg";